export class SetCurrentLanguage {
  static readonly type = '[CoreShared] Set Current Language'
  constructor(public lang: string) {}
}

export class SetLastVisitedLink {
  static readonly type = '[CoreShared] Set Last Visited Link'
  constructor(public url: string) {}
}
